import React from 'react';
import StockContext from '../../../contexts/StocksContext'
import StatusContext from '../../../contexts/StatusContext'
import Stack from '@mui/material/Stack'
import { ArrowForwardIconGray } from '../customicons/ArrowForwardIconGray';

import './stockstemplates.css'

export const FastAnalysis = () => {

let {
    changeLanguageEnglish,
  } = React.useContext(StatusContext);
  
  let {
     handleFastAnalysis
  } = React.useContext(StockContext);

  return (
     <div className="controls">
      <button
        type="button"
        onClick={handleFastAnalysis}
        className="add-btn"
      >
        <Stack  style={{textAlign:'center'}} direction="row" spacing={1}>
          <label style={{fontSize:'18px'}}>{changeLanguageEnglish("stocks", "fastanalysis")}</label>
          <ArrowForwardIconGray />
          </Stack>
      </button>
    </div>
  );
};
